import { Col, Form, Row } from "react-bootstrap";

const FormRedioCheck = ({ arrydata, title, handelValue, update }) => {

    const handelData = event => {
        handelValue(title, event.target.id);
    }
    return (
        <Row className='mt-3'>
            {
                arrydata.map((item, index) =>
                    <Col key={index} className='d-flex align-items-center' >
                        <Form.Check
                            type='radio'
                            id={item.id}
                            name={title}
                            label={item.title}
                            checked={update ? update.filter(find => find.optionId === item.id)[0] ? true : false : false}
                            onChange={handelData} />
                    </Col>
                )
            }

        </Row>
    );
}

export default FormRedioCheck;
